import React from 'react';
import { useParams } from 'react-router-dom';

function SevaUApp (){
    const { storeId } = useParams();
    return <h1>Welcome to the world of Geeks! {storeId}</h1>

}
  
export default SevaUApp;